import React from 'react';
import styled from 'styled-components';
import { AppState } from '../../store';
import { withRouter, useHistory } from 'react-router';
import { connect } from 'react-redux';
import { Card, CardActionButton, DynamicForm } from '../elements';
import { CONSTS } from '../elements/_constants';
import { UserInterface, NewUserInterface } from '../../store/base/types';
import { createNewUser } from '../../store/base/functions';
type NewUserComponentProps = {
    className?: string,
    match: any,
    onCreateNewUser: Function
}
const NewUserComponent = (props: NewUserComponentProps) => {
   let history = useHistory();
   const fields = [
      {
          id: "phone",
          htmltype : "phone",
          label : "تلفن همراه",
          defaultValue: '',
          required: true
      },
      {
          id : "first_name",
          htmltype : "text",
          label : "نام",
          defaultValue: '',
          required: true
      },
      {
          id : "last_name",
          htmltype: "text",
          label : "نام خانوادگی",
          defaultValue: '',
          required: true
      },
      {
          id: "email",
          htmltype: "email",
          label : "ایمیل",
          defaultValue: ''
      },
      {
         id: "password",
         htmltype: "password",
         label : "رمز عبور",
         defaultValue: '',
         required: true
      },
      {
         id: "password2",
         htmltype: "password",
         label : "تکرار رمز عبور",
         defaultValue: '',
         required: true
      }
  ]
  const handleSubmit = (data : NewUserInterface)=>{
      if(data.password != data.password2) {
         alert('عدم تطابق رمز عبور و تکرار آن');
         return
      }
      data.avatar_id = null;
      data.signature_id = null;
      props.onCreateNewUser(data,()=>{
         history.push('/users');
      });
  }
    return (
        <div className={props.className}>
          <Card
              title={"ایجاد کاربر جدید"}
              headerMeta={<>
                <CardActionButton title="بازگشت" to={`/users`} hasBorderRight={true}/>
              </>}
            >
              <DynamicForm fields={fields} onSubmit={handleSubmit}/>
            </Card>
        </div>
    )
}
const NewUser = styled(NewUserComponent)`
  @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
    padding-left: 15px;
  }
`

const mapStateToProps = (state: AppState,ownProps: any) => ({
});

const mapDispatchToProps = (dispatch:any) => {
    return {
      onCreateNewUser: (data :NewUserInterface,then?:Function) => dispatch(createNewUser(data,then))
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(NewUser));
